import React, { FC } from 'react';

import { track } from '@adsk/acs-web-analytics';
import { Flex, Box } from '@adsk/alloy-react-box';
import { ActionButton } from '@adsk/alloy-react-menu';
import { navigate } from '@adsk/exo-skeleton-api';

import { AnalyticsEvents } from '../../../constants';
import { BREAKPOINTS, PRODUCT_LINK_VARIANTS, ProductLinkType } from '../consts';

type ProductLinksMenuType = {
  links: ProductLinkType[];
};

const ProductLinksMenu: FC<ProductLinksMenuType> = ({ links }) => {
  if (!links.length) {
    return null;
  }

  return (
    <ActionButton
      data-testid="ProductLinksMenuButton"
      style={{
        height: 32,
        padding: '0 4px',
        [BREAKPOINTS.SMALL]: {
          display: 'inline-flex',
        },
      }}
      options={links.map(({ label, icon: Icon, variant, url }) => ({
        label,
        key: label,
        as: variant === PRODUCT_LINK_VARIANTS.EXTERNAL ? 'a' : 'button',
        href: variant === PRODUCT_LINK_VARIANTS.EXTERNAL ? url : undefined,
        target:
          variant === PRODUCT_LINK_VARIANTS.EXTERNAL ? '_blank' : undefined,
        onClick: async () => {
          if (!url) {
            return;
          }

          track(AnalyticsEvents.navigateToOtherProduct, {
            product_name: label,
          });

          if (variant === PRODUCT_LINK_VARIANTS.INTERNAL) {
            await navigate(url);
          }
        },
        renderIcon: () => (
          <Flex mr={13}>
            {Icon ? (
              <Icon size={20} />
            ) : (
              <Box
                width={22}
                height={22}
                borderRadius="50%"
                backgroundColor="adskBlue100"
              />
            )}
          </Flex>
        ),
      }))}
    />
  );
};

export default ProductLinksMenu;
